import { useLocation } from 'react-router-dom';
import { parseQueryString } from '../queryString';

/**
 * React Hook to access the url search params.
 */
export function useQueryString<T extends ReturnType<typeof parseQueryString>>() {
  return parseQueryString(useLocation().search) as T;
}
